import GreenButton from '../../components/green-button';
import PromotionsUtil from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';
import {navigate} from '../../../utils/navigation';

export default () => {
    return (
        <div className="modal animate__animated animate__fadeInUp animate__faster promotion-modal promotion-invite promotion-cashapp">
            <div className="modal-header">
                <div className="close" onClick={e => {
                    PromotionsUtil.closePromotionModal('promotions-cashapp');
                }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body">
                <div className="layer"><div className="cashapp"></div></div>
                <div className="layer">
                    <div className="content center" style={{justifyContent: 'flex-end'}}>
                        <div className="top">
                            <div className="title">CASH APP <span>PAY</span> Available now</div>
                            <div className="descriptions">Make deposits using your <b>favorite</b> method!</div>
                        </div>
                        <div className="center">
                            <div className="invite-stats">
                                <div className="invite-stats-title">

                                </div>
                            </div>
                        </div>
                        <div className="bottom">
                            <GreenButton onClick={e => {
                                PromotionsUtil.clickPromotionModals('promotions-cashapp', () => {
                                    ModalsLib.open('wallet');
                                });
                            }}>Make deposit</GreenButton>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    )
}